import { Model } from '@vuex-orm/core'
import Booking from './Booking'

export default class Customer extends Model {
  static entity = 'customers'

  static primaryKey = 'ref'

  static fields() {
    return {
      id: this.increment(),
      address: this.attr(''),
      assistances: this.attr([]),
      companion_name: this.attr(''),
      companion_phone: this.attr(''),
      email: this.attr(''),
      first_name: this.attr(''),
      follow_up_consent: this.attr(''),
      follow_up_consent_at: this.attr(''),
      general_notes: this.attr(''),
      last_name: this.attr(''),
      phone: this.attr(''),
      postcode: this.attr(''),
      ref: this.attr(''),
      title: this.attr(''),

      bookings: this.hasMany(Booking, 'customer_ref'),
    }
  }
}
